export const fieldsEditableByProgram = {
  preparedBy: ['A220'],
  checkedBy: ['A220'],
  taskDescription: ['*'],
  taskTitle: ['*'],
};

export const isFieldEditableByProgram = (field, program) => {
  return fieldsEditableByProgram[field]?.includes(program) || fieldsEditableByProgram[field]?.includes('*');
}